import styled from '@emotion/styled';

import type { TableColumnWidth } from '~/ui/core/table/Table';
import {
    TableContainer as BaseTableContainer,
    TableBody,
    TableCell,
    TableErrorMessage,
    TableExpandableRow,
    TableExpandButton,
    TableGrid,
    TableHeader,
    TableHeaderCell,
    TableLoadingSpinner,
    TableNameCell,
    TableNameCellContent,
    TableTreeLine,
} from '~/ui/core/table/Table';

export const COLUMNS_WIDTHS: ReadonlyArray<TableColumnWidth> = [
    'minmax(400px, auto)',
    '100px',
    '200px',
    '200px',
    '200px',
    '80px',
    '80px',
    '80px',
];

export const TableContainer = styled(BaseTableContainer)(({ theme }) => ({
    flex: 1,
    marginRight: theme.spacing.s,
}));

export const Grid = styled(TableGrid)({
    gridTemplateRows: 'auto 1fr',
    maxHeight: '100%',
});

export const GridHeader = styled(TableHeader)(({ theme }) => ({
    gridTemplateColumns: COLUMNS_WIDTHS.join(' '),
    padding: theme.spacing.s,
}));

export const GridHeaderCell = TableHeaderCell;

export const GridBody = TableBody;

export const GridRow = styled(TableExpandableRow)({
    gridTemplateColumns: COLUMNS_WIDTHS.join(' '),
    marginTop: 0,
});

export const GridCell = styled(TableCell)<{ readonly isLastRow?: boolean }>({});

export const GridLine = TableTreeLine;

export const ExpandButton = TableExpandButton;

export const NameCell = TableNameCell;

export const NameCellContent = TableNameCellContent;

export const LoadingSpinner = TableLoadingSpinner;

export const ErrorMessage = TableErrorMessage;

export const VirtualizedRowsContainer = styled.div({
    position: 'relative',
    width: '100%',
});

export const VirtualItem = styled.div({
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
});
